<!-- Overlay -->
<div
  class="dc-modal fixed inset-0 z-50 flex items-center justify-center bg-black/50"
>
  <!-- Container -->
  <div
    class="dc-modal-container relative w-full max-w-4xl max-h-[90vh] bg-white flex flex-col"
  >
    <!-- Close button -->
    <button
      class="modal-x-button absolute top-4 right-4 text-dc-gray-500 hover:text-dc-navy"
      type="button"
      (click)="close()"
    >
      <i class="fas fa-close text-lg"></i>
    </button>

    <!-- Header -->
    <div class="px-6">
      <h2 class="text-lg font-semibold text-dc-navy">
        {{ "MEM_DISCLAIMER.TITLE" | translate }}
      </h2>
      <p class="text-base! text-dc-gray-light!  mt-1 text-dc-gray-500">
        {{ "MEM_DISCLAIMER.LAST_UPDATED" | translate }}
      </p>
    </div>

    <!-- Body -->
    <div
      class="flex-1 px-6 text-base leading-relaxed text-dc-black-light"
    >
      <!-- INTRO -->
      <section>
        <h3 class="font-semibold text-lg  mb-2 text-dc-navy">
          {{ "MEM_DISCLAIMER.INTRO.TITLE" | translate }}
        </h3>
        @for (
          p of "MEM_DISCLAIMER.INTRO.PARAGRAPHS" | translate;
          track $index
        ) {
          <p class="text-base!  text-dc-gray-light!  mb-2">
            {{ p }}
          </p>
        }
      </section>

      <!-- MEMBERSHIP -->
      <section>
        <h3 class="font-semibold text-lg  mb-2 text-dc-navy">
          {{ "MEM_DISCLAIMER.MEMBERSHIP.TITLE" | translate }}
        </h3>

        <!-- Eligibility -->
        <h4 class="font-medium mt-3">
          {{ "MEM_DISCLAIMER.MEMBERSHIP.ELIGIBILITY.TITLE" | translate }}
        </h4>
        @for (
          p of "MEM_DISCLAIMER.MEMBERSHIP.ELIGIBILITY.PARAGRAPHS" | translate;
          track $index
        ) {
          <p class="text-base!  text-dc-gray-light!  mb-2">
            {{ p }}
          </p>
        }
        <!-- Obligations -->
        <h4 class="font-medium mt-4">
          {{ "MEM_DISCLAIMER.MEMBERSHIP.OBLIGATIONS.TITLE" | translate }}
        </h4>
        <p class="text-base!  text-dc-gray-light!  mb-2">
          {{ "MEM_DISCLAIMER.MEMBERSHIP.OBLIGATIONS.INTRO" | translate }}
        </p>

        <ul class="list-disc ltr:pl-6 rtl:pr-6 space-y-1">
          @for (
            item of "MEM_DISCLAIMER.MEMBERSHIP.OBLIGATIONS.ITEMS" | translate;
            track $index
          ) {
            <li class="text-base text-dc-gray-light">
              {{ item }}
            </li>
          }
        </ul>

        <p class="text-base!  text-dc-gray-light!  mt-3 text-dc-gray-600">
          {{ "MEM_DISCLAIMER.MEMBERSHIP.OBLIGATIONS.NOTE" | translate }}
        </p>
      </section>

      <!-- USE OF INFORMATION -->
      <section>
        <h3 class="font-semibold text-lg  mb-2 text-dc-navy">
          {{ "MEM_DISCLAIMER.USE_INFO.TITLE" | translate }}
        </h3>

        <h4 class="font-medium mt-3">
          {{ "MEM_DISCLAIMER.USE_INFO.GEN.TITLE" | translate }}
        </h4>
        @for (
          p of "MEM_DISCLAIMER.USE_INFO.GEN.PARAGRAPHS" | translate;
          track $index
        ) {
          <p class="text-base!  text-dc-gray-light!  mb-2">
            {{ p }}
          </p>
        }

        <h4 class="font-medium mt-4">
          {{ "MEM_DISCLAIMER.USE_INFO.OMISSION.TITLE" | translate }}
        </h4>
        @for (
          p of "MEM_DISCLAIMER.USE_INFO.OMISSION.PARAGRAPHS" | translate;
          track $index
        ) {
          <p class="text-base!  text-dc-gray-light!  mb-2">
            {{ p }}
          </p>
        }
      </section>

      <!-- LIMITATION OF LIABILITY -->
      <section>
        <h3 class="font-semibold text-lg  mb-2 text-dc-navy">
          {{ "MEM_DISCLAIMER.LIABILITY.TITLE" | translate }}
        </h3>

        <h4 class="font-medium mt-3">
          {{ "MEM_DISCLAIMER.LIABILITY.ELIGIBILITY.TITLE" | translate }}
        </h4>
        @for (
          p of "MEM_DISCLAIMER.LIABILITY.ELIGIBILITY.PARAGRAPHS" | translate;
          track $index
        ) {
          <p class="text-base!  text-dc-gray-light!  mb-2">
            {{ p }}
          </p>
        }

        <h4 class="font-medium mt-4">
          {{ "MEM_DISCLAIMER.LIABILITY.OBLIGATIONS.TITLE" | translate }}
        </h4>
        @for (
          p of "MEM_DISCLAIMER.LIABILITY.OBLIGATIONS.PARAGRAPHS" | translate;
          track $index
        ) {
          <p class="text-base!  text-dc-gray-light!  mb-2">
            {{ p }}
          </p>
        }
      </section>

      <!-- GENERIC SECTIONS -->
      @for (
        key of [
          "IP",
          "PRIVACY",
          "CONDUCT",
          "MODIFICATION",
          "LAW",
        ];
        track $index
      ) {
        <section>
          <h3 class="font-semibold text-lg  mb-2 text-dc-navy">
            {{ "MEM_DISCLAIMER." + key + ".TITLE" | translate }}
          </h3>
          @for (
            p of "MEM_DISCLAIMER." + key + ".PARAGRAPHS" | translate;
            track $index
          ) {
            <p class="text-base!  text-dc-gray-light!  mb-2">
              {{ p }}
            </p>
          }
        </section>
      }
    </div>
  </div>
</div>
